<template>
    <!-- Start Navbar -->
    <nav id="topnav" class="defaultscroll is-sticky">
        <div class="" :class="container">

            <!-- Logo container-->
            <router-link class="logo" to="/">
                <div class="block sm:hidden"> <!-- small screen -->
                    <img src="../assets/images/logo-impuls-triangle-transparent.png" class="h-10 inline-block" alt="">
                </div>
                <div class="sm:block hidden"> <!-- large screen-->
                    <img src="../assets/images/logo-impuls-long.jpg" class="h-[60px] inline-block dark:hidden" alt="">
                </div>
            </router-link>

            <div class="menu-extras" @click="handler">
                <div class="menu-item">
                    <a class="navbar-toggle" id="isToggle" :class="toggle === false ? '' : 'open'">
                        <div class="lines">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </a>
                </div>
            </div>

            <!-- Navigation Menu-->
            <div id="navigation" :class="toggle === false ? 'none' : 'block'">
                <ul class="navigation-menu">
                    <li v-for='link of links' :key="link.name" :class="activeMenu === link.name ? 'active' : ''"><span class="menu-arrow"></span>
                        <router-link :to="{ name: link.page, hash: link.name }" @click="activeMenu = link.name">{{ link.text }}</router-link>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script>
import vClickOutside from 'v-click-outside';
import feather from 'feather-icons'
export default {
    directives: {
        clickOutside: vClickOutside.directive,
    },
    props:{
        container:{
            type: String,
            required: true
        }
    },
    data() {
        return {
            toggle: false,
            activeMenu: '',
            menu: true,
            menuOpen: '',
            dropdownOpen: false,

            links: [
                {
                    text: 'Home',
                    page: 'home',
                    name: '#home'
                },
                {
                    text: 'Diensten',
                    page: 'home',
                    name: '#diensten'
                },
                {
                    text: 'Team',
                    page: 'home',
                    name: '#team'
                },
                {
                    text: 'Over ons',
                    page: 'home',
                    name: '#about'
                },
                {
                    text: 'Partners',
                    page: 'home',
                    name: '#partners'
                },
                {
                    text: 'Contact',
                    page: 'contact',
                    name: ''
                }
            ]
        }
    },
    created() {
        this.activeMenu = window.location.pathname
        window.addEventListener('scroll', this.handleScroll);
    },
    mounted() {
        document.addEventListener('click', this.handleClickOutside);
        feather.replace();
        this.scrollToTop()
    },
    unmounted() {
        window.removeEventListener('scroll', this.handleScroll);
        document.removeEventListener('click', this.handleClickOutside);
    },

    methods: {
        handler() {
            this.toggle = !this.toggle;
        },
        submenu(item) {
            this.menu = !this.menu
            this.menuOpen = item
        },
        handleScroll() {
            const navbar = document.getElementById("topnav");
            if (
                document.body.scrollTop >= 50 ||
                document.documentElement.scrollTop >= 50
            ) {
                navbar.classList.add("nav-sticky");
            } else {
                navbar.classList.remove("nav-sticky");
            }

            // Check and update active item
            this.links.forEach((item) => {
                if(item.name) {
                    const element = document.querySelector(item.name);
                    if (element) {
                        const rect = element.getBoundingClientRect();
                        if (rect.top <= window.innerHeight / 2 && rect.bottom >= window.innerHeight / 2) {
                            this.activeMenu = item.name;
                        }
                    }
                }
            });
        },
        handleClickOutside(event) {
            if (this.$refs.dropdownToggle && !this.$refs.dropdownToggle.contains(event.target)) {
                this.dropdownOpen = false;
            }
        },
        
        scrollToTop() {
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    },
    
}
</script>

<style lang="scss" scoped></style>